import React, { useState, useEffect } from 'react';
import api from '../../services/axiosInstance';

const CoursesManagement = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  // Fetch courses on component mount
  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await api.get('/free-courses'); 
      setCourses(response.data || []);
      console.log("(response.data",response.data)
      setLoading(false);
    } catch (error) {
      console.error('Error fetching courses:', error);
      setMessage('Error loading courses');
      setLoading(false);
    }
  };

  const updateCourseLink = (index, newLink) => {
    const updatedCourses = [...courses];
    updatedCourses[index] = {
      ...updatedCourses[index],
      fileLink: newLink
    };
    setCourses(updatedCourses);
  };

  const saveChanges = async () => {
    setSaving(true);
    setMessage('');
    
    try {
      await api.put('/free-courses', { years: courses }); 
      setMessage('Courses updated successfully!');
    } catch (error) {
      console.error('Error updating courses:', error);
      setMessage('Error updating courses');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg">Loading courses...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            Manage Course Links 
          </h1>

          {message && (
            <div className={`p-3 rounded mb-4 ${
              message.includes('Error') 
                ? 'bg-red-100 text-red-700' 
                : 'bg-green-100 text-green-700'
            }`}>
              {message}
            </div>
          )}

          <div className="space-y-4">
            {courses.map((course, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-lg font-semibold text-gray-700">
                    {course.year}
                  </h3>
                </div>
                
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-600">
                    File Link:
                  </label>
                  <input
                    type="url"
                    value={course.fileLink}
                    onChange={(e) => updateCourseLink(index, e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="https://drive.google.com/file/d/..."
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={saveChanges}
              disabled={saving}
              className={`px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                saving ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesManagement; 